import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import AuthorRelatedBlogsApp from './react-author-related-blogs';
var ReactAuthorRelatedBlogs = new ComponentBootstrap('author-related-blogs');
ReactAuthorRelatedBlogs.reactApp = AuthorRelatedBlogsApp;
ReactAuthorRelatedBlogs.run();